import { useEffect, useRef, useState } from "react";
import { ArrowRight } from "lucide-react";
import { useMagnetic } from "../hooks/useMousePosition";
import ProductShowcase3D from "./ProductShowcase3D";

const HEADLINE_LINES = [
  ["Six", "Categories."],
  ["One", "Trusted", "Export", "Partner."],
];

export default function Hero() {
  const [visible, setVisible] = useState(0);
  const magneticRef = useRef(null);
  useMagnetic(magneticRef, 6);

  const totalWords = HEADLINE_LINES.flat().length;

  useEffect(() => {
    let count = 0;
    const interval = setInterval(() => {
      count += 1;
      setVisible(count);
      if (count >= totalWords) clearInterval(interval);
    }, 100);
    return () => clearInterval(interval);
  }, [totalWords]);

  let wordIndex = 0;

  return (
    <section className="pt-4 md:pt-6 pb-0 mb-6 md:mb-8 bg-bg overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-[55%_45%] gap-6 lg:gap-10 items-center">
          <div>
            <p className="label-cap text-accent mb-3 animate-fade-up">Sourced from India, Delivered Worldwide</p>
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-[3.25rem] xl:text-6xl font-bold text-primary leading-[1.08] tracking-tight">
              {HEADLINE_LINES.map((line, li) => (
                <span key={li} className="block">
                  {line.map((word) => {
                    const idx = wordIndex++;
                    return (
                      <span
                        key={word + idx}
                        className="inline-block mr-[0.28em] transition-all duration-700"
                        style={{
                          opacity: visible > idx ? 1 : 0,
                          transform: visible > idx ? "translateY(0)" : "translateY(20px)",
                        }}
                      >
                        {word}
                      </span>
                    );
                  })}
                </span>
              ))}
            </h1>
            <p className="mt-4 text-base md:text-lg text-muted leading-relaxed max-w-xl">
              Bags, Apparel, Footwear, Watches, Jewellery &amp; Food — wholesale ready, private label
              available.
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <a href="#categories" className="btn-gold group">
                Browse Catalog <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
              </a>
              <a
                ref={magneticRef}
                href="#inquiry"
                className="btn-outline"
                style={{ transition: "transform 0.15s ease-out" }}
              >
                Submit Inquiry
              </a>
            </div>
          </div>

          <div className="relative flex justify-center lg:justify-end">
            <ProductShowcase3D />
          </div>
        </div>
      </div>
    </section>
  );
}
